import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Refresh as RefreshIcon, BugReport as BugReportIcon } from '@mui/icons-material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('❌ Erro capturado pelo Error Boundary:', error);
    console.error('📊 Stack:', errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            background: 'linear-gradient(135deg, #0F1115 0%, #141821 100%)',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              maxWidth: 500,
              p: 3,
              textAlign: 'center',
              backgroundColor: '#1a1f2e',
              border: '1px solid rgba(255, 82, 82, 0.2)',
            }}
          >
            <BugReportIcon
              sx={{
                fontSize: 60,
                color: '#ff5252',
                mb: 2,
              }}
            />
            
            <Typography
              variant="h5"
              sx={{
                color: '#fff',
                fontWeight: 700,
                mb: 2,
                fontFamily: "'Inter', sans-serif",
              }}
            >
              Ops! Algo deu errado
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                mb: 3,
                lineHeight: 1.6,
              }}
            >
              Ocorreu um erro inesperado. Por favor, recarregue a página.
            </Typography>

            {this.state.error && (
              <Box
                sx={{
                  backgroundColor: 'rgba(255, 82, 82, 0.1)',
                  borderRadius: 2,
                  p: 2,
                  mb: 3,
                  border: '1px dashed rgba(255, 82, 82, 0.3)',
                  maxHeight: 200,
                  overflow: 'auto',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: '#ff5252',
                    fontFamily: 'monospace',
                    fontSize: '0.75rem',
                    display: 'block',
                    textAlign: 'left',
                  }}
                >
                  {this.state.error.toString()}
                </Typography>
              </Box>
            )}

            <Button
              variant="contained"
              fullWidth
              startIcon={<RefreshIcon />}
              onClick={this.handleReload}
              sx={{
                background: 'linear-gradient(135deg, #F0B90B 0%, #F8D12F 100%)',
                color: '#000',
                fontWeight: 700,
                py: 1.5,
                textTransform: 'none',
                fontSize: '1rem',
                '&:hover': {
                  background: 'linear-gradient(135deg, #F8D12F 0%, #F0B90B 100%)',
                },
              }}
            >
              Recarregar Página
            </Button>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
